export default "__VITE_ASSET__brmA4dpc__"